import { render, staticRenderFns } from "./About.vue?vue&type=template&id=6654bb4d&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&id=6654bb4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654bb4d",
  null
  
)

export default component.exports